
import classNames from 'classnames'
import React, { useEffect, useMemo, useState } from 'react'
import usePreviewReportingData from '../../../../hooks/usePreviewReportingData'
import Badge from '../../../atoms/badge/Badge'
import Banner from '../../../atoms/banner/Banner'
import Clickable from '../../../atoms/clickable/Clickable'
import LoadingSpinner from '../../../atoms/loadingspinner/LoadingSpinner'
import VerticalGroup from '../../../atoms/verticalgroup/VerticalGroup'
import RoundResultsPage from '../../results/RoundResultsPage'


import '../ReportingTemplate.scss'
import ContentStretcher from './ContentStretcher'
import ReportingPagePreviewTile, { RENDERED_DIMENSIONS } from './ReportingPagePreviewTile'

interface Props {
  reportingTemplateId: string
  simulationId: string
  brandingId?: string
  round: number
  mode: 'fullscreen' | 'thumbnails'
  setMode: (val: 'fullscreen' | 'thumbnails') => void
  previewHeight: number
  previewWidth: number
  availableHeight: number
  availableWidth: number
}

const ReportingTemplatePreviewContent: React.FC<Props> = ({
  reportingTemplateId,
  simulationId,
  brandingId,
  round,
  mode,
  setMode,
  previewHeight,
  previewWidth,
  availableHeight,
  availableWidth
}) => {
  const { inProgress, error, data } = usePreviewReportingData(reportingTemplateId, simulationId, round, brandingId)
  const [selectedLayout, setSelectedLayout] = useState<API.ReportingTemplateLayoutResponse | null>(null)

  const slides = useMemo(() => {
    if (data) {
      return data.layouts.filter(layout => layout.enabled)
    }
    return []
  }, [data])

  useEffect(() => {
    if (mode === 'fullscreen' && selectedLayout == null) {
      setSelectedLayout(slides[0])
    }
  }, [mode, selectedLayout, slides])


  return <>
    {error && <Banner type='error' active={!!error} message={error?.message} />}
    {inProgress && <LoadingSpinner />}
    {!!data && !inProgress && <div className={classNames('reporting-template-select-container', {
      scrollable: mode === 'thumbnails'
    })}>
      {mode === 'thumbnails' && slides.map((layout, layoutIndex) => <Clickable key={layout.id} onClick={() => {
        setSelectedLayout(layout)
        setMode('fullscreen')
      }}>
        <ReportingPagePreviewTile
          data={{
            ...data,
            layouts: [layout]
          }}
          roundNumber={round}
          layout={layout}
          showHeader
          showTeamPositions
          overlay={<Badge value={layoutIndex + 1} colour='green' size={24} textSize='5xl' />}
        />
      </Clickable>)}
      {mode === 'fullscreen' && availableHeight > 0 && availableWidth > 0 && <VerticalGroup style={{flex: 1, height: availableHeight, width: availableWidth }} spread center>
        {selectedLayout != null && previewHeight > 0 && previewWidth > 0 && <ContentStretcher
          style={{
            background: '#e1e1e1',
            width: previewWidth,
            height: previewHeight,
            minHeight: previewHeight
          }}
          contentWidth={RENDERED_DIMENSIONS.width}
          contentHeight={RENDERED_DIMENSIONS.height}
        >
          <div style={{ width: RENDERED_DIMENSIONS.width, height: RENDERED_DIMENSIONS.height, minHeight: RENDERED_DIMENSIONS.height, position: 'absolute' }}>
            <RoundResultsPage
              data={{
                ...data,
                layouts: slides
              }}
              roundNumber={round}
              onlyThesePages={[]}
              startingLayout={selectedLayout.type}
            />
          </div>
        </ContentStretcher>}
      </VerticalGroup>}
    </div>}
  </>
}

export default ReportingTemplatePreviewContent